class APIS {
	apis() {
		return {
			fetch_mau_admin: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/mau/admin'
			},
			create_email: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/send/mail/mau'
			},
			fetch_mau: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/messages/mau'
			}
		};
	}
}

export default new APIS();
